import { createFileRoute } from '@tanstack/react-router'
import BlogPage from '@/pages/sites/blog-page'
import { ProtectedRoute } from '@/components/auth'
import { CAPABILITIES } from '@/constants/capabilities'

// Rota index para /dashboard/$dashboardId/sites/$siteId/blog
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/sites/$siteId/blog/',
)({
  component: function BlogIndexRoute() {
    const { dashboardId, siteId } = Route.useParams()

    return (
      <ProtectedRoute capability={CAPABILITIES.MANAGE_SITES_BLOG}>
        <BlogPage dashboardId={dashboardId} siteId={siteId} />
      </ProtectedRoute>
    )
  },
})
